import { isCloudSite } from "../electron-modules";
import { withOriginalID } from "../export/utils/misc";
import { Asset, TagAnnotation, TagData, TagItemData } from "../redux/assets-slice";
import { SceneCameraState } from "../redux/camera-slice";
import { TagSize } from "../types/tags";
import { engineCloudURL } from "../urls";


const createTagCollection = async (folderID: string, asset: Asset) => {
  if (!isCloudSite) return;

  const {texture, size} = asset.data as TagData;
  const tagCollection = {...asset, texture, size};
  delete tagCollection.data;

  try {
    const url = `${engineCloudURL}/api/folders/${folderID}/tag-collections`;
    await fetch(url, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(withOriginalID(tagCollection))
    });
  } catch(err) {
    console.error(err);
  }
};

const deleteTagCollection = async (assetID: string) => {
  if (!isCloudSite) return;

  try {
    const url = `${engineCloudURL}/api/tag-collections/${assetID}`;
    await fetch(url, {method: "DELETE"});
  } catch(err) {
    console.error(err);
  }
};

const updateTagCollection = async (assetID: string, options: {
  name?: string,
  visible?: boolean,
  size?: TagSize,
  texture?: string,
}) => {
  if (!isCloudSite) return;

  try {
    const url = `${engineCloudURL}/api/tag-collections/${assetID}`;
    await fetch(url, {
      method: "PUT",
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(options)
    });
  } catch(err) {
    console.error(err);
  }
};

const createTags = async (assetID: string, tags: TagItemData[]) => {
  if (!isCloudSite) return;

  try {
    const url = `${engineCloudURL}/api/tag-collections/${assetID}/tags`;
    await fetch(url, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(tags.map(tag => withOriginalID(tag)))
    });
  } catch(err) {
    console.error(err);
  }
};

const updateTag = async (tagID: string, options: {
  name?: string,
  comment?: string,
  sceneState?: SceneCameraState,
  annotations?: TagAnnotation[],
  assetID?: string,
  date?: string
}) => {
  if (!isCloudSite) return;

  if ("assetID" in options) {
    // api expects a different format
    options['assetId'] = options.assetID;
    delete options.assetID;
  }

  if ("annotations" in options) {
    // the update expects originalId
    (options as any)['annotations'] = options['annotations']
      .map(annotation => withOriginalID(annotation));
  }

  try {
    const url = `${engineCloudURL}/api/tags/${tagID}`;
    await fetch(url, {
      method: "PUT",
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(options)
    });
  } catch(err) {
    console.error(err);
  }
};

const deleteTag = async (tagID: string) => {
  if (!isCloudSite) return;

  try {
    const url = `${engineCloudURL}/api/tags/${tagID}`;
    await fetch(url, {method: "DELETE"});
  } catch(err) {
    console.error(err);
  }
};

const actions = {
  create: createTags,
  delete: deleteTag,
  update: updateTag,
  createCollection: createTagCollection,
  deleteCollection: deleteTagCollection,
  updateCollection: updateTagCollection
};

export default actions;